import * as React from 'react'

import {
  Avatar,
  type AvatarBadgeProps,
  type EnhancedDimension,
} from '@factorialco/deprecated-design-system'

import buildUrl from 'modules/core/lib/buildUrl'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'
import type User from 'modules/core/store/models/User'

interface Props {
  size?: EnhancedDimension
  user?: IAvatar | ComputedAvatar | User
  badge?: AvatarBadgeProps
}

interface IAvatar {
  avatar: string
  fullName: string | (() => string)
}

interface ComputedAvatar {
  avatar?: string | null
  fullName: string | (() => string)
}

function isUser(u: IAvatar | ComputedAvatar | User): u is User {
  return 'attributes' in u
}

const UserAvatar = (props: Props) => {
  const { user, size, badge } = props
  const avatar = user && user.avatar
  let userName = ''
  if (user) {
    if (isUser(user)) {
      userName = getFullDisplayName({
        firstName: user.attributes.first_name,
        lastName: user.attributes.last_name,
      })
    } else {
      const fullName = user.fullName
      userName = typeof fullName === 'function' ? fullName() : fullName
    }
  }

  return <Avatar size={size} url={buildUrl(avatar)} label={userName} badge={badge} />
}

export default UserAvatar
